module.exports = __webpack_public_path__ + "img/Group-8797.84892218.svg";